/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SDYourSettings.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_SD_GET_EXTERNAL_USER_SETTINGS = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `SDYOURSETTINGS/POST_SD_GET_EXTERNAL_USER_SETTINGS`
);

const POST_SD_SET_EXTERNAL_USER_SETTINGS = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `SDYOURSETTINGS/POST_SD_SET_EXTERNAL_USER_SETTINGS`
);

const GET_CODETABLES_BY_TABLE_NAME = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDYOURSETTINGS/GET_CODETABLES_BY_TABLE_NAME`
);

const GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS =
  ReduxUtils.generateFetchActionTypes(
    'ua-library',
    `SDYOURSETTINGS/GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS`
  );

const POST_SD_SEND_VERIFICATION_CODE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `SDYOURSETTINGS/POST_SD_SEND_VERIFICATION_CODE`
);

const POST_SD_VERIFY_SUBMITTED_CODE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `SDYOURSETTINGS/POST_SD_VERIFY_SUBMITTED_CODE`
);

export {
  POST_SD_GET_EXTERNAL_USER_SETTINGS,
  POST_SD_SET_EXTERNAL_USER_SETTINGS,
  GET_CODETABLES_BY_TABLE_NAME,
  GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS,
  POST_SD_SEND_VERIFICATION_CODE,
  POST_SD_VERIFY_SUBMITTED_CODE,
};
